import React, { ChangeEvent, FC, useCallback, useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, FormControl, Grid, MenuItem, TextField } from '@material-ui/core';
import { PartnerPartnership } from '../../../../models';
import { useStyles } from '../styles';
import { CustomDialogTitle, SelectControl } from '../../../../components';
import { useCommonStyles } from '../../../../styles';

interface Props {
  open: boolean;
  translation: any;
  partnerships: PartnerPartnership[];
  partnership?: PartnerPartnership;
  onClose: () => void;
  onCreateLink: (linkName: string, partnership: PartnerPartnership) => void;
}

export const DefaultLinkDialog: FC<Props> = ({ open, partnerships, partnership, translation, onClose, onCreateLink }) => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const [name, setName] = useState('');
  const [selectedPartnership, setSelectedPartnership] = useState<PartnerPartnership>();

  useEffect(() => {
    if (partnership) {
      setSelectedPartnership(partnership);
    }
  }, [partnership]);

  const createLink = () => {
    if (selectedPartnership) {
      onCreateLink(name, selectedPartnership);
    }
  };

  const handleClose = () => {
    onClose();
  };

  const handlePartnershipChange = useCallback(
    (event: ChangeEvent<{ value: any }>) => {
      const partnership = partnerships?.find((p) => p.id === Number(event.target.value));

      if (partnership) {
        setSelectedPartnership(partnership);
      }
    },
    [partnerships],
  );

  return (
    <Dialog onClose={handleClose} open={open} classes={{ paper: classes.dialog }}>
      <CustomDialogTitle title={translation.new_default_link} onClose={() => onClose()} />
      <Grid container direction="column">
        <Grid item xs={12}>
          <p className={commonClasses.formControlTitle}>{translation.link_name}</p>
          <TextField className={classes.inputField} value={name} onChange={(event) => setName(event.target.value)} variant="outlined" />
        </Grid>
        {partnerships && partnerships.length !== 0 && (
          <Grid item xs={12}>
            <p className={commonClasses.formControlTitle}>{translation.text_6275}</p>
            <FormControl variant="outlined" className={commonClasses.formControl} disabled={!!selectedPartnership}>
              <SelectControl value={selectedPartnership ? selectedPartnership.id : ''} onChange={handlePartnershipChange} minWidth={97}>
                {partnerships.map((partnership) => (
                  <MenuItem className={commonClasses.optionSelector} style={{ width: 'inherit' }} key={partnership.id} value={partnership.id}>
                    {partnership.partnershipCode}
                  </MenuItem>
                ))}
              </SelectControl>
            </FormControl>
          </Grid>
        )}
      </Grid>
      <DialogActions className={classes.dialogAction}>
        <Button onClick={createLink} className={`${commonClasses.activeDialogBtn} ${classes.btn}`}>
          {translation.create_link}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
